<ul class="no-bullets trigger-info-list"
    *uiContentLoading="loading$ | async; diameter: 75">
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_queue' | translate }}</span>
        <span class="value">{{ item?.queueDefinition?.name }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_status' | translate }}</span>
        <span class="value">{{ item?.status }}</span>
    </li>
    <li class="trigger-info"
        *ngIf="_itemId != item?.id">
        <span class="label">{{ 'job_trigger_detail_queue_item_retry_count' | translate }}</span>
        <span class="value">{{ item?.retryNumber }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_reference' | translate }}</span>
        <span class="value">{{ item?.reference }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_priority' | translate }}</span>
        <span class="value">{{ item?.priority }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_reviewer' | translate }}</span>
        <span class="value">{{ item?.reviewerUser?.userName }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_started' | translate }}</span>
        <span class="value">
            <ui-dateformat [date]="item?.startProcessing"
                           contentType="relative">
            </ui-dateformat>
        </span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_ended' | translate }}</span>
        <span class="value">
            <ui-dateformat [date]="item?.endProcessing"
                           contentType="relative">
            </ui-dateformat>
        </span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_queue_item_deadline' | translate }}</span>
        <span class="value">
            <ui-dateformat [date]="item?.dueDate"
                           contentType="relative">
            </ui-dateformat>
        </span>
    </li>
</ul>
